import {useRef, useState} from 'react'

import {Switch} from '@headlessui/react'

import emailJS from '@emailjs/browser';
import {useNavigate} from "react-router-dom";

emailJS.init(process.env.REACT_APP_USER_ID);

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Contact = () => {
    const [agreed, setAgreed] = useState(false)

    const firstName = useRef("")
    const lastName = useRef("")
    const team = useRef("")
    const email = useRef("")
    const message = useRef("")

    const navigate = useNavigate()

    return (
        <div className="bg-white py-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-24">
            <div className="relative max-w-xl mx-auto">
                <div className="text-center">
                    <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">We’re Here to
                        Help</h2>
                    <p className="mt-4 text-lg leading-6 text-gray-500">
                        If you have any questions or ran into a problem, we are here to help!
                    </p>
                </div>
                <div className="mt-12">
                    <form action="#" method="POST" onSubmit={event => {
                        event.preventDefault()

                        emailJS.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_SUPPORT_TEMPLATE_ID,{
                            firstName: firstName.current.value,
                            lastName: lastName.current.value,
                            team: team.current.value,
                            email: email.current.value,
                            message: message.current.value,
                            reply_to: email.current.value
                        }).then(() => {
                            navigate("/thanks");
                        }).catch(() => {
                            navigate("/error");
                        });
                    }} className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
                        <div>
                            <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                                First name
                            </label>
                            <div className="mt-1">
                                <input
                                    ref={firstName}
                                    required
                                    type="text"
                                    name="first-name"
                                    id="first-name"
                                    autoComplete="given-name"
                                    className="py-3 px-4 block w-full shadow-sm transition-colors focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                                Last name
                            </label>
                            <div className="mt-1">
                                <input
                                    ref={lastName}
                                    required
                                    type="text"
                                    name="last-name"
                                    id="last-name"
                                    autoComplete="family-name"
                                    className="py-3 px-4 block w-full shadow-sm transition-colors focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="team" className="block text-sm font-medium text-gray-700">
                                Team
                            </label>
                            <div className="mt-1">
                                <input
                                    ref={team}
                                    required
                                    type="text"
                                    name="team"
                                    id="team"
                                    autoComplete="organization"
                                    className="py-3 px-4 block w-full shadow-sm transition-colors focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email
                            </label>
                            <div className="mt-1">
                                <input
                                    ref={email}
                                    required
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    className="py-3 px-4 block w-full shadow-sm transition-colors focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                                Message
                            </label>
                            <div className="mt-1">
                                <textarea
                                    ref={message}
                                    required
                                    id="message"
                                    name="message"
                                    rows={4}
                                    className="py-3 px-4 block w-full shadow-sm transition-colors focus:ring-indigo-500 focus:border-indigo-500 border border-gray-300 rounded-md"
                                    defaultValue={''}
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <div className="flex items-start">
                                <div className="flex-shrink-0">
                                    <Switch
                                        checked={agreed}
                                        onChange={setAgreed}
                                        className={classNames(
                                            agreed ? 'bg-indigo-600' : 'bg-gray-200',
                                            'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'
                                        )}
                                    >
                                        <span className="sr-only">Agree to policies</span>
                                        <span
                                            aria-hidden="true"
                                            className={classNames(
                                                agreed ? 'translate-x-5' : 'translate-x-0',
                                                'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                                            )}
                                        />
                                    </Switch>
                                </div>
                                <div className="ml-3">
                                    <p className="text-base text-gray-500">
                                        By selecting this, you agree to the
                                        {' '}
                                        <a href="/terms" className="font-medium text-gray-700 underline">
                                            Terms
                                        </a>
                                        .
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <button
                                type="submit"
                                disabled={!agreed}
                                className={`w-full ${agreed ? "" : "pointer-events-none"} inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-brand transition-colors hover:bg-indigo-600`}
                            >
                                Let's talk
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact;
